import { SalesOrderContractTaskComment } from '@/hooks/api/models';
import axios from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';

/**
 * 1780. 受注案件契約タスクコメント登録
 * [POST] /workspaces/:identifier/teams/:team_id/sales_orders/:sales_order_id/sales_order_contract_tasks/:sales_order_contract_task_id/sales_order_contract_task_comments
 */
type Props = {
  identifier: string;
  team_id: number;
  sales_order_id: number;
  task_id: number;
  content: string;
  content_json: string;
  parent_id?: number;
};

const createSalesOrderContractTaskComment = (props: Props): Promise<SalesOrderContractTaskComment> => {
  return axios.post(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/sales_orders/${props.sales_order_id}/sales_order_contract_tasks/${props.task_id}/sales_order_contract_task_comments`,
    props
  );
};

export const useCreateSalesOrderContractTaskComment = () => {
  return useMutation({
    mutationFn: createSalesOrderContractTaskComment
  });
};